let env = "";

const setEnv = (configs) => {
	return new Promise((resolve, reject) => {
		env = configs;
		resolve(true);
	});
};
const getEnv = () => {
	return env;
};


export { env, setEnv, getEnv };
